import HttpService from '@/modules/shared/services/httpService';
import Vue from 'vue';
import router from '@/router';
import VueAppInsights from 'vue-application-insights';
import { AppConfigsModel } from '@/modules/shared/models/configs';

export default async function initializeApplication(): Promise<number> {
  const httpService = new HttpService();

  const result = await httpService.httpInstance.get<AppConfigsModel>('config.json');

  window.$config = result.data as AppConfigsModel;

  Vue.use(VueAppInsights, {
    id: result.data.applicationInsights.instrumentationKey,
    router,
    trackInitialPageView: true,
    onAfterScriptLoaded: (data: any) => {
      data.addTelemetryInitializer(
        (envelope: any) => {
          envelope.data.applicationName = result.data.applicationInsights.applicationName;
          if (typeof (envelope.baseData) === 'string') {
            const name = envelope.baseData;
            envelope.baseData = {};
            envelope.baseData.name = name;
          }
        },
      );
    },
  });

  return Promise.resolve(1);
}
